/*
 * chv-sticky-stack.js
 * Apilado por z-index para el scroll sticky de las secciones Chevignon.
 * Las secciones posteriores a una sticky reciben mayor z-index para cubrirla.
 *
 * Solo actúa sobre secciones "nuestras" (root con id chv-* o .chv-sticky-section);
 * nunca fuerza posición/fondo a secciones ajenas del tema.
 * Guard de init: aunque varias secciones lo carguen, corre una sola vez.
 */
(function () {
  'use strict';
  if (window.__chvStickyStackInit) return;
  window.__chvStickyStackInit = true;

  function isChvSection(shopifySection) {
    return !!shopifySection.querySelector('.chv-sticky-section, [id^="chv-lf"], [id^="chv-lfd"], [id^="chv-dj"]');
  }

  function getSectionBg(shopifySection) {
    var el = shopifySection.querySelector('[data-section-bg]');
    if (el) return el.getAttribute('data-section-bg');
    var innerSection = shopifySection.querySelector('.chv-leather-fits-page > section, [id^="chv-lf"] > section');
    if (innerSection) {
      var bg = window.getComputedStyle(innerSection).backgroundColor;
      if (bg && bg !== 'rgba(0, 0, 0, 0)' && bg !== 'transparent') return bg;
    }
    return '#ffffff';
  }

  function applyBg(shopifySection) {
    var bg = getSectionBg(shopifySection);
    shopifySection.style.backgroundColor = bg;
    var page = shopifySection.querySelector('.chv-leather-fits-page');
    if (page) page.style.backgroundColor = bg;
  }

  function initStickyStack() {
    var all = Array.from(document.querySelectorAll('.shopify-section'));

    // El header del tema siempre por encima de las secciones sticky.
    all.forEach(function (s) {
      var isHeader = s.querySelector('sticky-header, .header-wrapper') ||
                     s.classList.contains('shopify-section-group-header-group') ||
                     s.closest('.shopify-section-group-header-group');
      if (isHeader) s.style.zIndex = '1000';
    });

    // Solo nuestras secciones participan del stacking.
    var sections = all.filter(isChvSection);
    if (!sections.length) return;

    var hasStickyBefore = false;
    var zCounter = 1;

    sections.forEach(function (shopifySection) {
      var inner = shopifySection.querySelector('.chv-sticky-section');
      if (inner) {
        shopifySection.style.position = 'sticky';
        shopifySection.style.top = '0';
        var stackZ = inner.style.getPropertyValue('--chv-stack-z');
        shopifySection.style.zIndex = stackZ ? parseInt(stackZ) + 1 : zCounter;
        applyBg(shopifySection);
        hasStickyBefore = true;
        zCounter++;
      } else if (hasStickyBefore) {
        shopifySection.style.position = 'relative';
        shopifySection.style.zIndex = zCounter;
        applyBg(shopifySection);
        zCounter++;
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyStack);
  } else {
    initStickyStack();
  }

  // Editor de temas: re-evalúa el apilado al recargar una sección.
  document.addEventListener('shopify:section:load', initStickyStack);
}());
